"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextWithHtml = exports.SixMobileRoot = exports.Root = exports.LayoutHeader = exports.InnerTextWrapper = exports.InnerRoot = exports.BoxTitle = exports.BoxIcon = exports.BoxContent = exports.BenefitBox = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  renderOnMyPages
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(6),
  [theme.breakpoints.up('md')]: {
    margin: '0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: `min(${renderOnMyPages ? 974 : 1010}px, 100%)`
  }
}));
const LayoutHeader = exports.LayoutHeader = (0, _mui.styled)('div')({
  maxWidth: 860
});
const SixMobileRoot = exports.SixMobileRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2, 0),
  width: '100%',
  justifyContent: 'center'
}));
const InnerRoot = exports.InnerRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isInCarousel
}) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  width: '100%',
  gap: isInCarousel ? 0 : theme.spacing(2),
  margin: theme.spacing(0, 3),
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(0, 6),
    flexDirection: 'row',
    gap: isInCarousel ? 0 : theme.spacing(6)
  }
}));
const BenefitBox = exports.BenefitBox = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.primary.light,
  display: 'flex',
  boxSizing: 'border-box',
  justifyContent: 'start',
  alignItems: 'start',
  gap: theme.spacing(2),
  width: '100%',
  height: 139,
  padding: theme.spacing(4, 3),
  [theme.breakpoints.up('md')]: {
    width: 290
  }
}));
const BoxIcon = exports.BoxIcon = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'start',
  gap: theme.spacing(0, 2),
  svg: {
    width: 24,
    height: 24,
    color: theme.palette.text.primary
  }
}));
const BoxContent = exports.BoxContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));
const InnerTextWrapper = exports.InnerTextWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  height: 63
}));
const BoxTitle = exports.BoxTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  fontSize: '1.6rem',
  textOverflow: 'ellipsis',
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.text.primary
}));
const StyledTextWithHtml = exports.StyledTextWithHtml = (0, _mui.styled)(_presentationComponents.TextWithHtml)(({
  theme
}) => ({
  fontSize: '1.4rem',
  color: theme.palette.text.secondary
}));
